import ImageKit from 'imagekit-javascript';
import { Transformation } from 'imagekit-javascript/dist/src/interfaces/Transformation';

import { config } from '../config';

export const imagekit = new ImageKit({
  publicKey: config.imgkit.publicKey || '',
  urlEndpoint: config.imgkit.urlEndpoint || '',
});

type ImageSize = 'thumb' | 'full' | 'hero' | 'highlight' | 'og';

const transformations: Record<ImageSize, Array<Transformation>> = {
  thumb: [{ width: '300', height: '300', focus: 'auto' }],
  full: [{ width: '1500', height: '1500', crop: 'at_max' }],
  hero: [{ height: '400', aspectRatio: '3-1', focus: 'auto' }],
  highlight: [{ height: '500', aspectRatio: '4-3', focus: 'auto' }],
  og: [{ width: '800', height: '400', focus: 'auto' }],
};

export const imageSize = (url: string, size: ImageSize) => {
  return imagekit.url({ src: url, transformation: transformations[size] });
};
